export const STATUS_LABELS = {
  todo: "До виконання",
  in_progress: "В роботі",
  done: "Виконано",
  cancelled: "Скасовано",
};

export const PRIORITY_LABELS = {
  low: "Низький",
  medium: "Середній",
  high: "Високий",
};

export const PRIORITY_ICONS = {
  low: "fa-solid fa-circle",
  medium: "fa-solid fa-circle-minus",
  high: "fa-solid fa-circle-exclamation",
};

export const getStatusLabel = (status) =>
  STATUS_LABELS[status] || "Невідомий статус";

export const getPriorityLabel = (priority) =>
  PRIORITY_LABELS[priority] || "Невідомий пріоритет";

export const formatDateTime = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const yyyy = d.getFullYear();
  const mo = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  const hh = String(d.getHours()).padStart(2, "0");
  const mm = String(d.getMinutes()).padStart(2, "0");
  return `${yyyy}-${mo}-${dd} ${hh}:${mm}`;
};

export const formatCreatedDateUk = (iso) => formatDateTime(iso);

export const isTaskOverdue = (task) => {
  // E1/E2 — terminal and cancelled rows are never overdue.
  if (!task || task.status === "done" || task.status === "cancelled") {
    return false;
  }
  if (!task.due_date) return false;
  const due = new Date(task.due_date);
  if (Number.isNaN(due.getTime())) return false;
  return due.getTime() < Date.now();
};

export const userDisplayName = (user) => {
  if (!user) return "—";
  if (user.fullname && String(user.fullname).trim()) return user.fullname;
  if (user.email && String(user.email).trim()) return user.email;
  if (user.id != null) return `Користувач #${user.id}`;
  return "—";
};

export const clientDisplayName = (client, clientId) => {
  if (client) {
    if (client.fullname && String(client.fullname).trim()) return client.fullname;
    const parts = [client.first_name, client.last_name].filter(Boolean);
    if (parts.length > 0) return parts.join(" ");
    if (client.email) return client.email;
  }
  if (clientId != null) return `Клієнт #${clientId}`;
  return "Без клієнта";
};

export const propertyTitleOrFallback = (property, propertyId) => {
  if (property && property.title) return property.title;
  if (propertyId != null) return `Об'єкт #${propertyId}`;
  return "—";
};
